/**
 * Constants for clinic location manager (施術管理者) API payload and form roots.
 */

/** API payload block key for はり・きゅう (create manager) */
export const MANAGER_STORE_BLOCK_A2 = 'BLOCK_A2';

/** API payload block key for マッサージ (create manager) */
export const MANAGER_STORE_BLOCK_R2 = 'BLOCK_R2';

/** React-hook-form / Zod top-level keys for those blocks (not the API strings above). */
export const BLOCK_A2 = 'a2';

export const BLOCK_R2 = 'r2';

/**
 * Modal title when deleting a 施術管理者 from admin UI.
 * Kept for explicit imports; same copy as STANDARD_DELETE_CONFIRM_TITLE.
 */
export { STANDARD_DELETE_CONFIRM_TITLE as CLINIC_LOCATION_MANAGER_DELETE_MODAL_TITLE } from './deleteConfirm';
